<template>
  <v-row>
    <v-col cols="12" md="12" lg="12" v-if="editable">
      <v-row style="align-items: self-end;">
         <v-col class="pb-0 pt-0" cols="12" md="6">
          <el-text-field
            disabled
            label="Įgaliojimo identifikavimo kodas"
            v-model="mandateData.mandate_code"
          />
        </v-col>
        <v-col class="pb-0 pt-0" cols="12" md="6" />
        <!-- <v-col class="pb-0 pt-0" cols="12" md="6" v-if="isSubmandate || mandateData.parent_id">
          <el-text-field
            disabled
            label="Įgaliojimo (tėvinio) identifikavimo kodas"
            v-model="mandateData.parent.mandate_code"
            :maxlength="200"
          />
        </v-col>
        <v-col class="pb-0 pt-0" cols="12" md="6" v-if="isSubmandate || mandateData.parent_id">
          <el-checkbox
            disabled
            class="mt-0 mb-1"
            style="width: fit-content"
            label="Įgaliojimas, duotas perįgaliojant"
            v-model="isSubmandateComp"
          />
        </v-col> -->
        <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
          <el-date-picker
            required
            pastDates
            label="Įgaliojimo patvirtinimo data"
            v-model="mandateData.confirm_date"
          />
        </v-col>
        <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
          <el-text-field
            required
            label="Sudarymo vieta"
            v-model="mandateData.form_place"
            :maxlength="200"
          />
        </v-col>
        <v-col class="pb-0 pt-0" cols="12" md="6">
          <el-text-field
            required
            :label="getNotarialCodeTitle"
            v-model="mandateData.notarial_no"
            :maxlength="20"
          />
        </v-col>
        <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
          <div class="info-text" v-if="showCancelableInfoText">{{ $t('Įgaliotojas įgaliojimo negalės panaikinti') }}</div>
          <el-autocomplete
            required
            :items="enums.logicSelect"
            enums
            itemvalue="value"
            itemtext="text"
            label="Įgaliojimo atšaukiamumas"
            v-model="mandateData.cancelable"
          />
        </v-col>
        <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
          <div class="info-text" v-if="showTermInfoText">{{ $t('Įgaliojimas nebus automatiškai išregistruojamas') }}</div>
          <el-autocomplete
            required
            :items="formatedTerms"
            enums
            itemvalue="value"
            itemtext="text"
            label="Įgaliojimo terminas"
            v-model="mandateData.term"
          />
        </v-col>
        <v-col class="pb-0 pt-0" v-if="showTermDate" cols="12" md="6">
          <el-date-picker
            required
            v-if="showTermDate"
            :pastDate="getPastDate"
            :beforeDates="getPastDate"
            futureDates
            label="Termino data"
            v-model="mandateData.term_date"
          />
        </v-col>
        <v-col class="pb-0 pt-0" v-else-if="showTermEvent" cols="12" md="12">
          <el-textarea
            label="Įvykio aprašymas"
            v-model="mandateData.term_event"
            :maxlength="2000"
            required
          />
        </v-col>
        <v-col v-else md="6" class="d-none d-md-block" />

        <v-col class="pb-0 pt-0" cols="12" md="12">
          <el-textarea
            label="Pastabos"
            v-model="mandateData.notes"
            :maxlength="2000"
          />
        </v-col>

        <v-col class="pb-0 pt-0" cols="12">
          <el-checkbox style="width: fit-content;" class="mt-0" label="Įgaliojimas veiksmams užsienyje atlikti" v-model="mandateData.order_abroad"/>
        </v-col>

        <v-col class="pb-0 pt-0" cols="12">
          <el-checkbox style="width: fit-content;" class="mt-0" label="Suteikiama teisė perįgalioti" v-model="mandateData.submandate_allowed"/>
        </v-col>

        <v-col class="pt-0" cols="12" v-if="mandateData.from_foreign_mandate != 1 && !(isSubmandate || mandateData.parent_id)">
          <el-checkbox style="width: fit-content;" class="mt-0" label="Užsienyje patvirtinto įgaliojimo, kuris buvo perįgaliotas, duomenys" v-model="mandateData.from_foreign_mandate"/>
        </v-col>

        <template v-if="mandateData.from_foreign_mandate && !(isSubmandate || mandateData.parent_id)">
          <v-col cols="12"><hr></v-col>
          <v-col class="pt-0" cols="12" v-if="mandateData.from_foreign_mandate == 1">
            <el-checkbox style="width: fit-content;" class="mt-0" label="Užsienyje patvirtinto įgaliojimo, kuris buvo perįgaliotas, duomenys" v-model="mandateData.from_foreign_mandate"/>
          </v-col>
          <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
            <el-date-picker
              :required="mandateData.from_foreign_mandate"
              pastDates
              label="Įgaliojimo patvirtinimo data"
              v-model="mandateData.foreign_mandate_confirm_date"
            />
          </v-col>

          <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
            <el-text-field
              :required="mandateData.from_foreign_mandate"
              label="Registracijos numeris"
              v-model="mandateData.foreign_mandate_notarial_no"
              :maxlength="20"
            />
          </v-col>

          <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
            <el-date-picker
              pastDates
              label="Pažymos (Apostille) data"
              v-model="mandateData.apostille_date"
            />
          </v-col>

          <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
            <el-text-field
              label="Pažymos (Apostille) numeris"
              v-model="mandateData.apostille_number"
              :maxlength="40"
            />
          </v-col>

          <v-col class="pb-0 pt-0" cols="12" md="12">
            <el-textarea
              :required="mandateData.from_foreign_mandate"
              label="Užsienio valstybės pareigūno, patvirtinusio sudarytą įgaliojimą, pareigos, vardas, pavardė"
              v-model="mandateData.foreign_mandate_confirm_person"
              :maxlength="1000"
            />
          </v-col>
        </template>

        <template v-if="(isSubmandate || mandateData.parent_id) && mandateData.from_foreign_mandate">
          <v-col cols="12"><hr></v-col>
          <v-col cols="12"><h2>Užsienyje patvirtinto įgaliojimo, kuris buvo perįgaliotas, duomenys</h2></v-col>
          <v-col class="pb-0 pt-0" cols="12" md="12" lg="12">
            <el-simple-table :items="dataListForeignMandate" />
          </v-col>
        </template>
      </v-row>
    </v-col>
    <v-col class="pb-0 pt-0" cols="12" md="12" lg="12" v-else>
      <el-simple-table :items="dataList" />
    </v-col>
  </v-row>
</template>

<script>

import InJournalTypes from '@/components/constants/inJournalTypes'
import InJournalStatus from '@/components/constants/inJournalStatus'
import Roles from '@/components/constants/roles'
import Enums from '@/enums'
import moment from 'moment'

export default {
  name: 'DataProvider',
  components: {},
  props: {
    mandateData: [Array, Object],
    inJournalType: [Number, String],
    inJournalStatus: [Number, String],
    isSubmandate: [Boolean]
  },
  data() {
    return {
      enums: Enums,
    }
  },
  created(){
      if (this.mandateData.parent) {
      this.$set( this.mandateData, 'original_term_date', this.mandateData.parent.term_date)
      this.$set(this.mandateData, 'original_term', this.mandateData.parent.term)
      }
      if(this.inJournalType == InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA && this.inJournalStatus == InJournalStatus.RENGIAMAS && this.mandateData.original_term === "1102"){
         this.$set( this.mandateData,'term', "1101")
         this.$set( this.mandateData,'term_date', moment(this.getRegistrationDate).add(1, 'years').format('YYYY-MM-DD'))
      }
  },
  computed: {
    showCancelableInfoText(){
      return this.showInfoText && this.mandateData.cancelable == '1'
    },
    showTermInfoText(){
      return this.showInfoText && this.mandateData.term == '1103'
    },
    showInfoText(){
      return this.inJournalType == InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA || this.inJournalType == InJournalTypes.PRANESIMAS_APIE_PAKEITIMA
    },
    formatedTerms() {
      if (this.mandateData.original_term == '1101') {
        return this.enums.subterms
      } else if (this.mandateData.original_term == '1102') {
        return this.enums.subterms
      } else if (this.mandateData.original_term == '1103') {
        return this.enums.subterms
      } else {
        return this.enums.terms
      }
    },
    getRegistrationDate() {
      return (this.mandateData.registration_date || this.mandateData.parent.registration_date)
    },
    getPastDate() {
      if (!this.isSubmandate) {
        return '9999-01-01'
      }
      if (this.mandateData.original_term_date) {
        return this.mandateData.original_term_date
      } else {
        return moment(this.getRegistrationDate).add(1, 'years').format('YYYY-MM-DD')
      }
    },
    isSubmandateComp() {
      return this.isSubmandate || this.mandateData.parent_id
    },
    showTermEvent() {
      return this.mandateData.term === '1103'
    },
    showTermDate() {
      return this.mandateData.term === '1101'
    },
    editable() {
      return [InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA, InJournalTypes.PRANESIMAS_APIE_PAKEITIMA, InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS].includes(this.inJournalType) && this.inJournalStatus == InJournalStatus.RENGIAMAS
    },
    getNotarialCodeTitle() {
      const roles = this.$store.getters.userRole;
      return roles.includes(Roles.KAL_VAD) ? 'Registracijos numeris' : 'Notarinio registro (registracijos) numeris'
    },
    dataList() {
      return [
        {
          title: 'Identifikavimo kodas',
          value: this.mandateData.mandate_code,
        },
        {
          title: 'Įregistravimo data',
          value: this.mandateData.registration_date,
        },
        {
          title: 'Įgaliojimo patvirtinimo data',
          value: this.mandateData.confirm_date,
        },
        {
          title: 'Sudarymo vieta',
          value: this.mandateData.form_place,
        },
        {
          title: this.getNotarialCodeTitle,
          value: this.mandateData.notarial_no,
        },
        {
          title: 'Įgaliojimo atšaukiamumas',
          value: this.mandateData.cancelable == "0" || this.mandateData.cancelable === true ? 'Atšaukiamas' : 'Neatšaukiamas',
        },
        {
          title: 'Terminas',
          value: Enums.terms.lt[this.mandateData.term] ?? '',
        },
        {
          title: 'Termino data',
          value: this.mandateData.term_date,
          hide: !this.showTermDate
        },
        {
          title: 'Įvykio aprašymas',
          value: this.mandateData.term_event,
          hide: !this.showTermEvent
        },
        {
          title: 'Pastabos',
          value: this.mandateData.notes,
        },
        {
          title: "Įgaliojimas veiksmams užsienyje atlikti",
          value: this.mandateData.order_abroad ? 'Taip' : 'Ne',
        },
        {
          title: "Suteikiama teisė perįgalioti",
          value: this.mandateData.submandate_allowed ? 'Taip' : 'Ne',
        },
        {
          title: "Užsienyje patvirtinto įgaliojimo, kuris buvo perįgaliotas, duomenys",
          value: ' ',
          hide: !this.mandateData.from_foreign_mandate,
        },
        {
          title: "Įgaliojimo patvirtinimo data",
          value: this.mandateData.foreign_mandate_confirm_date,
          hide: !this.mandateData.from_foreign_mandate,
        },
        {
          title: "Registracijos numeris",
          value: this.mandateData.foreign_mandate_notarial_no,
          hide: !this.mandateData.from_foreign_mandate,
        },
        {
          title: "Pažymos (Apostille) data",
          value: this.mandateData.apostille_date,
          hide: !this.mandateData.from_foreign_mandate,
        },
        {
          title: "Pažymos (Apostille) numeris",
          value: this.mandateData.apostille_number,
          hide: !this.mandateData.from_foreign_mandate,
        },
        {
          title: "Užsienio valstybės pareigūno, patvirtinusio sudarytą įgaliojimą, pareigos, vardas, pavardė",
          value: this.mandateData.foreign_mandate_confirm_person,
          hide: !this.mandateData.from_foreign_mandate,
        }
      ]
    },
    dataListForeignMandate() {
      return [
        {
          title: "Įgaliojimo patvirtinimo data",
          value: this.mandateData.foreign_mandate_confirm_date,
          hide: !this.mandateData.from_foreign_mandate,
        },
        {
          title: "Registracijos numeris",
          value: this.mandateData.foreign_mandate_notarial_no,
          hide: !this.mandateData.from_foreign_mandate,
        },
        {
          title: "Pažymos (Apostille) data",
          value: this.mandateData.apostille_date,
          hide: !this.mandateData.from_foreign_mandate,
        },
        {
          title: "Pažymos (Apostille) numeris",
          value: this.mandateData.apostille_number,
          hide: !this.mandateData.from_foreign_mandate,
        },
        {
          title: "Užsienio valstybės pareigūno, patvirtinusio sudarytą įgaliojimą, pareigos, vardas, pavardė",
          value: this.mandateData.foreign_mandate_confirm_person,
          hide: !this.mandateData.from_foreign_mandate,
        }
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.info-text {
  padding-bottom: 6px;
  padding-left: 2px;
  color: red;
  font-style: italic;
}
</style>
